import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSzak, getKepzesCelja, createKepzesCelja, updateKepzesCelja, getSzakfelelosBySzakkod } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import SideTile from "../SideTile";
// import "./KepzesCelja.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { KEPZESCELJA_TRANSLATIONS } from './KepzesCeljaTranslations';
import { SZAK_ALLAPOTA_OPTIONS, SZAK_ILLESZKEDES_OPTIONS, TARSADALMI_HATAS_OPTIONS } from './KepzesCeljaOptions';



const KepzesCeljaContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [kepzesCelja, setKepzesCelja] = useState({
        filling_status: 1 // Default value for filling_status
    });

    // New state for radio button selection
    const [szakAllapotaValasztas, setSzakAllapotaValasztas] = useState("");
    const [szakIlleszkedes, setSzakIlleszkedes] = useState([]); // Changed to array for checkboxes
    const [szakIlleszkedesEgyebText, setSzakIlleszkedesEgyebText] = useState("");
    const [tarsadalmiHatas, setTarsadalmiHatas] = useState([]);
    const [tarsadalmiHatasEgyebText, setTarsadalmiHatasEgyebText] = useState("");
    const [tarsadalmiHatasMegjegyzes, setTarsadalmiHatasMegjegyzes] = useState("");
    const [szakAllapotaMegjegyzes, setSzakAllapotaMegjegyzes] = useState("");
    const [finalized, setFinalized] = useState(false); // To track if the section is finalized
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    const [isNew, setIsNew] = useState(true);
    const [kepzesCeljaContent, setKepzesCeljaContent] = useState(null); // Store a_kepzes_celja from szakfelelosok
    const [kompetenciaterkepContent, setKompetenciaterkepContent] = useState(null); // Store kompetenciaterkep
    const [kepzesBemenetContent, setKepzesBemenetContent] = useState(null); // Store kepzes_bemeneti_kovetelmenyek
    const [kepzesiKimenetContent, setKepzesiKimenetContent] = useState(null); // Store kepzesi_es_kimeneti_kovetelmenyek

    // Get translations and options for current language - only after loading is complete
    const t = loading ? {} : (KEPZESCELJA_TRANSLATIONS[language] || KEPZESCELJA_TRANSLATIONS.hu);
    const szakAllapotaOptions = loading ? [] : (SZAK_ALLAPOTA_OPTIONS[language] || SZAK_ALLAPOTA_OPTIONS.hu);
    const szakIlleszkedesOptions = loading ? [] : (SZAK_ILLESZKEDES_OPTIONS[language] || SZAK_ILLESZKEDES_OPTIONS.hu);
    const tarsadalmiHatasOptions = loading ? [] : (TARSADALMI_HATAS_OPTIONS[language] || TARSADALMI_HATAS_OPTIONS.hu);

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    // Adatok lekérdezése és új bejegyzés létrehozása, ha szükséges
    useEffect(() => {
        const fetchData = async () => {
            try {
                // First, fetch szak data to get szak_kod
                const szakResponse = await getSzak(szakId);
                const szakKod = szakResponse.data.data.szak_kod;
                setSzakStatus(szakResponse.data.data.status); // Beállítjuk a szak státuszát
                
                // Fetch szakfelelős data to get a_kepzes_celja
                const szakfelelosResponse = await getSzakfelelosBySzakkod(szakKod);
                if (szakfelelosResponse.data && szakfelelosResponse.data.a_kepzes_celja) {
                    setKepzesCeljaContent(szakfelelosResponse.data.a_kepzes_celja);
                }
                if (szakfelelosResponse.data && szakfelelosResponse.data.kompetenciaterkep) {
                    setKompetenciaterkepContent(szakfelelosResponse.data.kompetenciaterkep);
                }
                if (szakfelelosResponse.data && szakfelelosResponse.data.kepzes_bemeneti_kovetelmenyek) {
                    setKepzesBemenetContent(szakfelelosResponse.data.kepzes_bemeneti_kovetelmenyek);
                }
                if (szakfelelosResponse.data && szakfelelosResponse.data.kepzesi_es_kimeneti_kovetelmenyek) {
                    setKepzesiKimenetContent(szakfelelosResponse.data.kepzesi_es_kimeneti_kovetelmenyek);
                }

                const kepzesCeljaResponse = await getKepzesCelja(szakId);

                // Ellenőrzés, hogy van-e már adat
                if (kepzesCeljaResponse.data.data.kepzesCelja.length > 0) {
                    const data = kepzesCeljaResponse.data.data.kepzesCelja[0];
                    setKepzesCelja(data);
                    setFinalized(data.filling_status === 3);

                    // Load radio button selections from JSONB
                    if (data.szak_allapota_valasztas) setSzakAllapotaValasztas(data.szak_allapota_valasztas.selected || "");
                    if (data.szak_allapota_megjegyzes) setSzakAllapotaMegjegyzes(data.szak_allapota_megjegyzes);
                    if (data.szak_illeszkedes_valasztas) setSzakIlleszkedes(data.szak_illeszkedes_valasztas.selected || []);
                    if (data.szak_illeszkedes_egyeb_text) setSzakIlleszkedesEgyebText(data.szak_illeszkedes_egyeb_text);
                    if (data.tarsadalmi_hatas_valasztas) {
                        const sel = data.tarsadalmi_hatas_valasztas.selected;
                        setTarsadalmiHatas(Array.isArray(sel) ? sel : sel ? [sel] : []);
                    }
                    if (data.tarsadalmi_hatas_egyeb_text) setTarsadalmiHatasEgyebText(data.tarsadalmi_hatas_egyeb_text);
                    if (data.tarsadalmi_hatas_megjegyzes) setTarsadalmiHatasMegjegyzes(data.tarsadalmi_hatas_megjegyzes);

                    setIsNew(false);
                } else {
                    // Ha 404-es hiba érkezik, új rekord létrehozása
                    console.log("No data found, creating a new record with filling_status = 1");
                    const newKepzesCelja = {
                        filling_status: 1
                    };
                    await createKepzesCelja(szakId, newKepzesCelja); // Új rekord létrehozása
                    setKepzesCelja(newKepzesCelja); // Helyi állapot frissítése
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.log("404 Error: No data found for the given UUID, creating a new entry with filling_status = 1");
                    const newKepzesCelja = {
                        filling_status: 1
                    };
                    await createKepzesCelja(szakId, newKepzesCelja); // Új rekord létrehozása
                    setKepzesCelja(newKepzesCelja); // Helyi állapot frissítése
                    window.location.reload(); // Oldal frissítése

                } else {
                    console.error("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId, navigate]);

    useEffect(() => {
        const textareas = document.querySelectorAll("textarea");
        textareas.forEach((textarea) => {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        });
    }, [kepzesCelja]);

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = {
                ...kepzesCelja,
                filling_status: 2,
                szak_allapota_valasztas: buildRadioData(szakAllapotaValasztas, szakAllapotaOptions),
                szak_allapota_megjegyzes: szakAllapotaMegjegyzes,
                szak_illeszkedes_valasztas: buildMultiSelectData(szakIlleszkedes, szakIlleszkedesOptions),
                szak_illeszkedes_egyeb_text: szakIlleszkedesEgyebText,
                tarsadalmi_hatas_valasztas: buildMultiSelectData(tarsadalmiHatas, tarsadalmiHatasOptions),
                tarsadalmi_hatas_egyeb_text: tarsadalmiHatasEgyebText,
                tarsadalmi_hatas_megjegyzes: tarsadalmiHatasMegjegyzes
            };
            try {
                if (isNew) {
                    await createKepzesCelja(szakId, updatedData);
                } else {
                    await updateKepzesCelja(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [kepzesCelja, isNew, szakId, registerSaveHandler, unregisterSaveHandler,
        szakAllapotaValasztas, szakAllapotaMegjegyzes, szakIlleszkedes, szakIlleszkedesEgyebText,
        tarsadalmiHatas, tarsadalmiHatasEgyebText, tarsadalmiHatasMegjegyzes]);

    const handleSzakAllapotaRadioChange = (value) => {
        setSzakAllapotaValasztas(value);
    };

    const handleTarsadalmiHatasCheckboxChange = (value) => {
        setTarsadalmiHatas((prev) => {
            if (prev.includes(value)) {
                if (value === 'tarsadalmihatas_egyeb') setTarsadalmiHatasEgyebText("");
                return prev.filter((v) => v !== value);
            }
            return [...prev, value];
        });
    };

    const handleSzakAllapotaMegjegyzes = (value) => {
        setSzakAllapotaMegjegyzes(value);
    };

    const handleTarsadalmiHatasMegjegyzes = (value) => {
        setTarsadalmiHatasMegjegyzes(value);
    };

    const handleSzakIlleszkedesEgyebTextChange = (value) => {
        setSzakIlleszkedesEgyebText(value);
    };

    const handleTarsadalmiHatasEgyebTextChange = (value) => {
        setTarsadalmiHatasEgyebText(value);
    };

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = {
            ...kepzesCelja,
            filling_status: status,
            szak_allapota_valasztas: buildRadioData(szakAllapotaValasztas, szakAllapotaOptions),
            szak_allapota_megjegyzes: szakAllapotaMegjegyzes,
            szak_illeszkedes_valasztas: buildMultiSelectData(szakIlleszkedes, szakIlleszkedesOptions),
            szak_illeszkedes_egyeb_text: szakIlleszkedesEgyebText,
            tarsadalmi_hatas_valasztas: buildMultiSelectData(tarsadalmiHatas, tarsadalmiHatasOptions),
            tarsadalmi_hatas_egyeb_text: tarsadalmiHatasEgyebText,
            tarsadalmi_hatas_megjegyzes: tarsadalmiHatasMegjegyzes
        };
        try {
            if (isNew) {
                await createKepzesCelja(szakId, updatedData);
            } else {
                await updateKepzesCelja(szakId, updatedData);
            }
            window.location.reload(); // Oldal újratöltése a mentés után
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-mintaterve`);
    };

    const handleBack = () => {
        navigate(`/szakjelentesek/${szakId}/alapadatok`);
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // All radio buttons must have a selection, and szak_illeszkedes must have at least one checkbox
        const hasAllRadioSelections = szakAllapotaValasztas && szakIlleszkedes.length > 0 && tarsadalmiHatas.length > 0;

        // Check "egyéb" text fields only if "egyéb" is selected
        const egyebFieldsValid =
            (!szakIlleszkedes.includes('szakilleszkedes_egyeb') || hasContent(szakIlleszkedesEgyebText)) &&
            (!tarsadalmiHatas.includes('tarsadalmihatas_egyeb') || hasContent(tarsadalmiHatasEgyebText));

        return (
            hasAllRadioSelections &&
            egyebFieldsValid
        );
    };

    const handleRevertFinalize = async (e) => {
        handleSubmit(e, 2); // Status 2-re állítása
    };

    const handleFinalize = async (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };

    const handleChange = (field, value) => {
        setKepzesCelja(prevState => ({
            ...prevState,
            [field]: value, // Save the updated HTML content
        }));
    };

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    {/* 1.1-es előretöltött rész */}
                    <div className="card">
                        <h2>{t.section1.title}</h2>
                        <div className="form-group">
                            <div
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: kepzesCeljaContent || '<p style="color: #999;">Nincs elérhető adat</p>' }} 
                            />
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        <div className="form-group">
                            {szakAllapotaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szakallapota_${option.value}`}
                                        name="szakallapota"
                                        value={option.value}
                                        checked={szakAllapotaValasztas === option.value}
                                        onChange={(e) => handleSzakAllapotaRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`szakallapota_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section2.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="szak_allapota_megjegyzes"
                                value={szakAllapotaMegjegyzes}
                                onChange={handleSzakAllapotaMegjegyzes}
                                disabled={finalized}
                            />
                        </div>

                    </div>

                    <div className="card">
                        <h2>{t.section3.title}</h2>
                        <p>{t.section3.description}</p>
                        <h4>{t.section3.subtitle}</h4>
                        <div className="form-group">
                            {szakIlleszkedesOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`szakilleszkedes_${option.value}`}
                                        name="szakIlleszkedes"
                                        value={option.value}
                                        checked={szakIlleszkedes.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSzakIlleszkedes([
                                                    ...szakIlleszkedes,
                                                    option.value
                                                ]);
                                            } else {
                                                setSzakIlleszkedes(
                                                    szakIlleszkedes.filter(val => val !== option.value)
                                                );
                                            }
                                        }}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`szakilleszkedes_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {szakIlleszkedes.includes("szakilleszkedes_egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="szak_illeszkedes_egyeb_text"
                                        value={szakIlleszkedesEgyebText}
                                        onChange={handleSzakIlleszkedesEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section4.title}</h2>
                        <div className="form-group">
                            {tarsadalmiHatasOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`tarsadalmihatas_${option.value}`}
                                        name={`tarsadalmiHatas_${option.value}`}
                                        value={option.value}
                                        checked={tarsadalmiHatas.includes(option.value)}
                                        onChange={() => handleTarsadalmiHatasCheckboxChange(option.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`tarsadalmihatas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {tarsadalmiHatas.includes("tarsadalmihatas_egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="tarsadalmi_hatas_egyeb_text"
                                        value={tarsadalmiHatasEgyebText}
                                        onChange={handleTarsadalmiHatasEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                        <h4>{t.section4.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="tarsadalmi_hatas_megjegyzes"
                                value={tarsadalmiHatasMegjegyzes}
                                onChange={handleTarsadalmiHatasMegjegyzes}
                                disabled={finalized}
                            />
                        </div>
                    </div>

                    {/* 1.5-ös előretöltött rész */}
                    <div className="card">
                        <h2>{t.section5.title}</h2>
                        <div className="form-group">
                            <div
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: kompetenciaterkepContent || '<p style="color: #999;">Nincs elérhető adat</p>' }}
                            />
                        </div>
                    </div>

                    {/* 1.6-os előretöltött rész */}
                    <div className="card">
                        <h2>{t.section6.title}</h2>
                        <div className="form-group">
                            <div
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: kepzesBemenetContent || '<p style="color: #999;">Nincs elérhető adat</p>' }}
                            />
                        </div>
                    </div>

                    {/* 1.7-es előretöltött rész */}
                    <div className="card">
                        <h2>{t.section7.title}</h2>
                        <div className="form-group">
                            <div
                                className="read-only-content"
                                dangerouslySetInnerHTML={{ __html: kepzesiKimenetContent || '<p style="color: #999;">Nincs elérhető adat</p>' }}
                            />
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={finalized ? handleRevertFinalize : handleFinalize} disabled={szakStatus >= 2}>
                            {finalized ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const KepzesCelja = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <KepzesCeljaContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default KepzesCelja;
